import React from "react";
import Grid from "@mui/material/Grid2";
import useStyles from "../styles/sections/HeroSection";
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const marketingVideoUrl = "/videos/GoodbyeCarBrasil1.mp4";

const HeroSection = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const onClickRegister = () => {
    navigate("/registro");
  };

  const onClickLogin = () => {
    navigate("/login");
  };

  return (
    <div id="home-section">
      <Grid container className={classes.container} justifyContent={"center"}>
        <div className={classes.overlay} />
        <Grid size={{ xs: 12, md: 6 }} className={classes.content}>
          <Typography variant="h2" className={classes.title}>
            Venda seu carro sem burocracia.
          </Typography>
          <Typography variant="h5">
            Anuncie no app e tenha uma proposta em até 24 horas.
          </Typography>

          {isMobile && (
            <Grid
              size={12}
              sx={{ textAlign: "center", mb: 4, marginTop: "24px" }}
            >
              <Box
                component="video"
                src={marketingVideoUrl}
                controls
                autoPlay
                muted
                sx={{
                  width: "80%",
                  maxHeight: "500px",
                  borderRadius: "8px",
                  boxShadow: 3,
                }}
              />
            </Grid>
          )}
        </Grid>
        <Grid className={classes.form}>
          <Card className={classes.formCard}>
            <CardContent>
              <Box sx={{ flexGrow: 1, textAlign: "center" }}>
                <Typography variant="h6" sx={{ mb: 2 }}>
                  Comece agora mesmo
                </Typography>

                {/* Botão principal com ícone */}
                <Button
                  onClick={onClickRegister}
                  className={classes.button}
                  variant="contained"
                  size="large"
                  fullWidth
                  sx={{ mb: 2 }}
                >
                  Cadastre-se Gratuitamente
                </Button>

                <Button
                  onClick={() => navigate("/comprador/login")}
                  variant="outlined"
                  fullWidth
                  sx={{ mb: 2, color: "white", borderColor: "white" }}
                >
                  Acesso comprador / revenda
                </Button>

                <Typography variant="body2" sx={{ mb: 2 }}>
                  Ou entre com:
                </Typography>

                {/* Botões de login social */}
                <Button
                  onClick={onClickLogin}
                  variant="outlined"
                  fullWidth
                  sx={{ mb: 2, color: "white", borderColor: "white" }}
                >
                  Google
                </Button>

                <Typography variant="body2" sx={{ mt: 2 }}>
                  Já tem uma conta?{" "}
                  <span
                    style={{ color: "white", cursor: "pointer" }}
                    onClick={onClickLogin}
                  >
                    Faça login
                  </span>
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default HeroSection;
